/* eslint-disable*/
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/prop-types */

import React, { useRef, useState, useEffect } from 'react';
import 'suneditor/dist/css/suneditor.min.css';
import EditIcon from '@material-ui/icons/Edit';

import InfoPopoverComments from '../InfoPopoverComments';

export default function InfoPopoverCommentsWrapper({ dashboardComments, section, title }) {
  const [dashboardComment, setDashboardComment] = useState(null);

  const generateUUID = () => {
    let dt = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = (dt + Math.random() * 16) % 16 | 0;
      dt = Math.floor(dt / 16);
      return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
    });
    return uuid;
  };

  const findComment = async (dashboardComments, titleTextParam, dashboardSectionText) => {
    try {
      // Create a Set to track unique identifiers
      const uniqueIdentifiers = new Set();
      const uniqueComments = dashboardComments?.filter((comment) => {
        const identifier = `${comment.dashboardSectionText}-${comment.titleText}`;
        if (!uniqueIdentifiers.has(identifier)) {
          uniqueIdentifiers.add(identifier);
          return true;
        }
        return false;
      });

      // Filter comments that match the titleTextParam and dashboardSectionText
      const filteredComments = uniqueComments?.filter(
        (comment) =>
          comment.dashboardSectionText === dashboardSectionText &&
          comment.titleText === titleTextParam,
      );

      // Check if filteredComments is empty, if so, call createMyCommentObj

      return filteredComments.length > 0
        ? filteredComments
        : [createMyCommentObj(dashboardSectionText, titleTextParam)];
    } catch (error) {
      console.error('Error in findComment:', error);
      return [];
    }
  };

  function createMyCommentObj(dashboardSectionText, titleTextParam) {
    if (titleTextParam?.toLowerCase() === 'header') {
      return {
        comment: `<p><span style="font-size: 14px"><strong>Source</strong>: </span><br><strong>Formula</strong>: </span><br><br><strong>Last Year</strong><br> From January 1, [year] to<br> December 31, [year].</p>`,
        commentId: generateUUID(),
        dashboardSectionText: dashboardSectionText,
        titleText: titleTextParam,
      };
    } else {
      return {
        comment:
          '<p><span style="font-size: 14px"><strong>Source</strong>: </span><br><strong>Formula</strong>: </span><br><br><strong>Notes: </strong><br></p>',
        commentId: generateUUID(),
        dashboardSectionText: dashboardSectionText,
        titleText: titleTextParam,
      };
    }
  }

  useEffect(() => {
    const fetchDashboardComment = async () => {
      const comment = await findComment(dashboardComments, section, title);
      setDashboardComment(comment);
    };

    fetchDashboardComment();
  }, [dashboardComments, section, title]);

  return <InfoPopoverComments dashBoardComment={dashboardComment?.[0]} />;
}
